import { toggleScroll } from "./toggleScroll";

export function mainNav() {
    // const body = $("body");
    let mainNav = $(".main-nav");
    let menuDrop = mainNav.find(".menu-item-has-children");
    let menuOpenClass = "menu-opened";
    let isIos = function () {
        return [
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform)
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    };

    menuDrop.each(function () {
        $(this).find(">a").after("<button class='mobile-menu-opener'></button>");
    });

    toggleScroll.$body.on("click", ".mobile-menu-opener", function () {
        let $parent = $(this).parent();

        if (window.innerWidth < 1200 || toggleScroll.$body.hasClass("touch") || isIos()) {
            if ($parent.hasClass("active")) {
                $parent.removeClass("active").find("ul").slideUp(400);
            } else {
                menuDrop.removeClass("active").find("ul").slideUp(400);
                $parent.addClass("active").find("ul").slideDown(400);
            }
        }
    });

    $(".menu-opener").on("click", function (e) {
        e.preventDefault();
        if (toggleScroll.$body.hasClass(menuOpenClass)) {
            toggleScroll.unLockScroll(menuOpenClass);
        } else {
            toggleScroll.lockScroll(menuOpenClass);
        }
    });


}


// WEBPACK FOOTER //
// ./assets/js/modules/mainNav.js